import { Component, Input, signal, WritableSignal } from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { ButtonVariant } from '@app/components/button/button.component';
import { PdfGeneratorService } from '@shared/services/pdfGenerator/pdfGenerator.service';

export enum CertificateColor {
  green = 'green',
  blue = 'blue',
}

@Component({
  selector: 'pl-certificate',
  templateUrl: './certificate.component.html',
})
export class CertificateComponent {
  @Input({ required: true }) public buttonTitle!: string;
  @Input({ required: true }) public certificateName!: string;
  @Input({ required: true }) public certificateJsonFileToGeneratePdf!: string;
  @Input({ required: true }) public color!: CertificateColor;
  @Input({ required: true }) public title!: string;
  @Input({ required: true }) public lockedMessage!: string | null;

  protected readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;
  protected readonly CertificateColor: typeof CertificateColor = CertificateColor;
  protected readonly PlIcon: typeof PlIcon = PlIcon;

  public disableButton: WritableSignal<boolean> = signal(false);

  constructor(private pdfGeneratorService: PdfGeneratorService) {}

  public async generateCertificate(): Promise<void> {
    if (!this.disableButton()) {
      this.disableButton.set(true);
      await this.pdfGeneratorService.generateAndDownloadPdf(this.certificateJsonFileToGeneratePdf);
      this.disableButton.set(false);
    }
  }
}
